export default {
    timers: {
        respawn: {
            delay: 1000,
            repeat: 3,
        },
    },
    dimension: {
        boundary: {
            width: 3975,
            height: 4000,
        },
    },
};
